<template>
  <div class="filterBar" >
    <div class="filterBar-content" ref="marketplaceRef">
      <div class="marketplace" v-if="props.platform === 'publisher'||props.platform === 'operator'" >
        <span>{{ st('reports.filterBar.marketplace') }}</span>
        <artmisads-select style="width: 232px" v-model:value="props.params.marketplace" @change="onChangeCountry"
          :getPopupContainer="() => marketplaceRef">
          <template v-for="option in COUNTRY_BASE" :key="option.countryCode">
            <a-select-option class="country-select-item" :value="option.host">
              <Icon :name="option.icon"></Icon>
              <span>{{ option.host }}</span>
            </a-select-option>
          </template>
        </artmisads-select>
      </div>
       <div class="item" v-if="props.platform === 'operator' && !props.hideOperatorUserFilters">
          <span>{{ st('reports.filterBar.aaUsername') }}</span>
          <artmisads-select
            show-search
            v-model:value="props.params.sellerId"
            style="width: 232px"
            :options="sellerOptions"
            @search="searchSeller"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @change="handleChangeSeller"
            :placeholder="st('common.all')"
            allowClear
          />
        </div>
       <div class="item" v-if="props.platform === 'operator' && !props.hideOperatorUserFilters">
          <span>{{ st('reports.filterBar.publisher') }}</span>
          <AdminPublisherSelect
            v-model="props.params.publisherId"
            :marketplace="props.params.marketplace"
            :placeholder="st('common.all')"
          />
        </div>
      <div class="date">
        <span>{{ st('reports.filterBar.dateRange') }}</span>
        <artemisads-range-picker :allowClear="false" :value="hackValue || dateParams" @openChange="onOpenChange"
          :presets="rangePresets" :disabled-date="disabledDate" @change="onChangeDate" :getPopupContainer="() => marketplaceRef"
          @calendarChange="onCalendarChange" />
      </div>
      <div class="brand" v-if="!props.type">
        <span>{{ st('reports.filterBar.brand') }}</span>
        <AdminBrandSelect
          v-model="props.params.brandId"
          :platform="props.platform"
          :marketplace="props.params.marketplace"
          :placeholder="st('common.all')"
          :getPopupContainer="() => marketplaceRef"
          @change="onChangeBrand"
        />
      </div>
      <div class="product" v-if="!props.type">
        <span>{{ st('reports.filterBar.product') }}</span>
        <artmisads-select show-search v-model:value="props.params.asin" style="width: 232px" :options="productOptions"
          @search="searchProduct" :show-arrow="false" :filter-option="false" :not-found-content="null" :placeholder="st('common.all')"
          allowClear @change="onChangeProduct" :getPopupContainer="() => marketplaceRef"/>
      </div>
      <div ref="primaryTrackingIdRef" class="trankingId" v-if="props.type === 'trackingId'">
        <span>{{ st('reports.filterBar.primaryId') }}</span>
        <!-- <artmisads-select v-model:value="props.params.primaryTrackingId" style="width: 232px"
          :options="primaryTrackingIdOptions" :show-arrow="false" :filter-option="false" :not-found-content="null"
          placeholder="" allowClear @change="onChangeProduct" /> -->
        <artmisads-select allowClear style="width: 232px" class="country" :dropdownMatchSelectWidth="false"
          v-model:value="primaryTrackingId" @select="(value, option) => setPrimaryTrackingId(value, option)"
          @change="(value) => handlePrimaryTrackingIdChange(value)"
          :getPopupContainer="() => $refs.primaryTrackingIdRef">
          <a-select-option class="source-select-item" v-for="item in primaryTrackingIdOptions" :key="item.id"
            :value="item.id" :dataItem="item">
            {{ item.name }}
          </a-select-option>
        </artmisads-select>
      </div>
      <div class="trankingId" v-if="props.type === 'trackingId'" ref="subTrackingIdRef">
        <span>{{ st('reports.filterBar.subId') }}</span>
        <artmisads-select allowClear style="width: 232px" class="country" :dropdownMatchSelectWidth="false"
          v-model:value="subTrackingId" @select="(value, option) => onChangePrimaryTrackingId(value, option)"
          @change="(value) => handleSubTrackingIdChange(value)"
          :getPopupContainer="() => $refs.subTrackingIdRef">
          <a-select-option class="source-select-item" v-for="item in subTrackingIdOptions" :key="item.id"
            :value="item.id" :dataItem="item">
            {{ item.name }}
          </a-select-option>
        </artmisads-select>
        <!-- <artmisads-select v-model:value="subTrackingId" style="width: 232px"
          :options="subTrackingIdOptions" :show-arrow="false" :filter-option="false" :not-found-content="null"
          placeholder="" allowClear @change="onChangeProduct" /> -->
      </div>
    </div>
  </div>
</template>
<script setup>
import moment from 'moment'
import { ref, watch, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import { COUNTRY_BASE } from '~/contants/common'
import { RANGE_PRESETS } from '~/contants/reports'
import Icon from '../Icon.vue'
import AdminPublisherSelect from '../AdminPublisherSelect.vue'
import AdminBrandSelect from '../AdminBrandSelect.vue'
import { reportsApi, publisherReportsApi,publisherAdminApi } from '~/server/index'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()

const RANGE_PRESET_KEYS = [
  'reports.filterBar.presetLast7Days',
  'reports.filterBar.presetLast14Days',
  'reports.filterBar.presetLast30Days',
  'reports.filterBar.presetLast90Days',
  'reports.filterBar.presetLastYear',
]

const rangePresets = computed(() =>
  RANGE_PRESETS.map((preset, i) => ({
    label: st(RANGE_PRESET_KEYS[i]),
    value: preset.value,
  })),
)

const dateParams = ref([
  moment().subtract(30, 'day'), moment()
])

// 注释掉之前的 watch，因为它可能导致问题
// watch(() => props.dateParams, (newValue) => {
//   if (newValue && newValue.length === 2 && moment.isMoment(newValue[0]) && moment.isMoment(newValue[1])) {
//     dateParams.value = newValue
//   }
// }, { immediate: true })
const sellerOptions = ref([]);
  const searchSeller = async keyword => {
    const params = {
      keyword,
      marketplace: props.params.marketplace
    };
    let data = await publisherAdminApi.searchSeller(params);
    if (data && data.length) {
      data = data.map(item => {
        item.value = item.id;
        item.label = item.sellerName;
        item.sellerBrands = item.sellerBrands.map(i => {
          i.value = i.id;
          i.label = i.amazonBrandName;
          return i;
        })
        return item;
      })
      sellerOptions.value = data;
    }
  }
const productOptions = ref([])
const dates = ref()
const hackValue = ref()
const marketplaceRef = ref(null)
const primaryTrackingIdOptions = ref([])
const subTrackingIdOptions = ref([])
const allSubTrackingIdOptions = ref([])
const subTrackingId = ref('')
const primaryTrackingId = ref('')
const props = defineProps({
  params: { type: Object, default: () => ({}) },
  dateParams: { type: Array, default: () => [] },
  setParams: { type: Function, default: undefined },
  platform: { type: String, default: '' },
  type: { type: String, default: '' },
  hideOperatorUserFilters: { type: Boolean, default: false },
})

watch(() => props.dateParams, (newValue) => {
  // console.log('props.dateParams changed:', newValue)
  if (newValue && newValue.length === 2) {
    dateParams.value = [moment(newValue[0]), moment(newValue[1])]
  }
}, { deep: true, immediate: true })
const disabledDate = current => {
  let notDate = false, tooLate = false, tooEarly = false
  notDate = current.valueOf() > moment().valueOf()
  if (dates.value && dates.value.length) {
    tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 365
    tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 365
  }
  return notDate || tooEarly || tooLate
}

const onOpenChange = open => {
  if (open) {
    dates.value = []
    hackValue.value = []
  } else {
    hackValue.value = undefined
  }
}
const onChange = val => {
  dateParams.value = val
}
const onCalendarChange = val => {
  dates.value = val
}

const onChangeDate = val => {
  if (val) {
    dateParams.value = val
    const dateTime = {
      startReportDateTimestamp: val[0].startOf('day').valueOf(),
      endReportDateTimestamp: val[1].startOf('day').valueOf(),
    }

    props.setParams(dateTime)
  } else {
    dateParams.value = []
  }
}

const searchProduct = async asin => {
  const params = {
    asin,
    marketplace: props.params.marketplace
  }
  let res
  if (props.platform === 'publisher') {
    res = await publisherReportsApi.getPublisherProductSearch(params)
  } else if (props.platform === 'seller') {
    res = await reportsApi.getSellerProductSearch(params)
  }else if(props.platform === 'operator'){
    const searchParams={
      sellerId: props.params.sellerId,
      ...params
    }
    res = await publisherAdminApi.searchAsin(searchParams)
   
  }
  let { success, data } = res
  if (success) {
    data = data.map(item => {
      const newItem = {
        value: item,
        label: item
      }
      return newItem
    })
    productOptions.value = data
  }
}

const onChangeBrand = brandId => {
  props.setParams({ brandId })
}

const onChangeProduct = asin => {
  props.setParams({ asin })
}

const onChangeCountry = marketplace => {
  props.setParams({ marketplace })
}
const getAllSubTrackingId = async () => {
  subTrackingIdOptions.value = []
  primaryTrackingIdOptions.value.forEach(item => {
    if (item.subTrackingIds?.length > 0) {
      item.subTrackingIds.forEach(subItem => {
        subTrackingIdOptions.value.push({
          name: subItem.trackingId,
          id: String(subItem.id),
          parentId: String(item.id)
        })
      })
    }
  })
  allSubTrackingIdOptions.value = JSON.parse(JSON.stringify(subTrackingIdOptions.value))
}
const getTrackingId = async () => {
  let { success, data, error } = await publisherReportsApi.getTrackingIds({ page: 1, size: 10000 }).catch(e => ({ success: false, error: e.message }))
  if (success) {
    primaryTrackingIdOptions.value = data.data.map(item => {
      if (item.subTrackingIds?.length > 0) {
        item.subTrackingIds.forEach(subItem => {
          subTrackingIdOptions.value.push({
            name: subItem.trackingId,
            id: String(subItem.id),
            parentId: String(item.id)
          })
        })
      }
      return {
        name: item.trackingId,
        id: String(item.id),
        subTrackingIds: item.subTrackingIds
      }
    })
    allSubTrackingIdOptions.value = JSON.parse(JSON.stringify(subTrackingIdOptions.value))
  }
  else {
    message.error(error)
  }
}
const getSubTrackingId = async (id) => {
  let { success, data, error } = await publisherReportsApi.getSubTrackingIds(id).catch(e => ({ success: false, error: e.message }))
  if (success) {
    subTrackingIdOptions.value = data.map(item => {
      return {
        name: item.trackingId,
        id: String(item.id),
        parentId: String(id)
      }
    })
  } else {
    message.error(error)
  }
}
const setPrimaryTrackingId = (primaryTrackingId, option) => {
  subTrackingIdOptions.value = []
  subTrackingId.value = ''
  // console.log('primaryTrackingId', primaryTrackingId)
  getSubTrackingId(primaryTrackingId)
  props.setParams({ primaryTrackingId: option.dataItem.name,subTrackingId:undefined })
}
const onChangePrimaryTrackingId = async (value, option) => {
  primaryTrackingId.value = option.dataItem.parentId
  getSubTrackingId(primaryTrackingId.value)
  const primaryTrackingIdName = primaryTrackingIdOptions.value.find(item => {
    return item.id === option.dataItem.parentId
  }).name
  // console.log('primaryTrackingIdName', primaryTrackingIdName)
  props.setParams({ primaryTrackingId: primaryTrackingIdName,subTrackingId: option.dataItem.name})
}
const handlePrimaryTrackingIdChange = (value) => {
  if (!value) {
    // 当值为空时，说明是清除操作
    subTrackingIdOptions.value = []
    subTrackingId.value = ''
    getAllSubTrackingId()
    props.setParams({ primaryTrackingId: undefined,subTrackingId:undefined })
  }
}
const handleSubTrackingIdChange = (value) => {
  if (!value) {
    props.setParams({ subTrackingId: undefined })
  }
}
onMounted(() => {
  if (props.type === 'trackingId') {
    getTrackingId()
  }
  
})
// getTrackingId()
</script>
<style lang="less" scoped>
   .item {
    display: flex;
    flex-direction: column;
    // margin-right: 50px;
    > span {
      color: var(--dark-2);
      font-weight: 500;
      font-size: 13px;
      letter-spacing: 0.3px;
      line-height: 18px;
      margin-bottom: 4px;
    }
  }
.filterBar {
  display: flex;
  padding: 0 16px;

  :deep(.country-select-item) {
    .ant-select-item-option-content {
      display: flex;

      svg {
        align-self: center;
        margin-right: 4px;
      }
    }
  }

  .filterBar-content {
    padding: 16px;
    background-color: var(--bg-gray-1);
    width: 100%;
    display: flex;
    gap: 20px;
    // justify-content: space-between;
    border-radius: 8px;
    flex-wrap: wrap;
  }
}

.marketplace,
.date,
.product,
.brand,
.trankingId {
  display: flex;
  flex-direction: column;

  >span {
    color: var(--dark-2);
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-bottom: 4px;
  }
}

.marketplace {
  display: flex;
  align-content: center;

  :deep(.ant-select-selection-item),
  :deep(.ant-select-item-option-content) {
    display: flex;
    align-items: center;

    .iconfont {
      margin-right: 4px;
      font-size: 18px;
    }
  }
}

</style>
